import Footer from "./Footer";
import myData from "./data.json";
import * as React from "react";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.css";

function TableData() {
  const parsedData = JSON.parse(myData);
  return (
    <>
      <div className="container">
        <h4>Full Data</h4>
        <Table responsive striped bordered hover size="sm">
          <thead>
            <tr>
              <th scope="col">Product Name</th>
              <th scope="col">Manufacturer</th>
              <th scope="col">Actual</th>
              <th scope="col">Labelled</th>
              <th scope="col">Mislabelled</th>
              <th scope="col">Arsenic</th>
              <th scope="col">Cadium</th>
              <th scope="col">Lead</th>
              <th scope="col">Copper</th>
            </tr>
          </thead>
          <tbody>
            {parsedData.map((item, idx) => (
              <tr key={idx}>
                <td>
                  <b>{item.ProductName}</b>
                </td>
                <td>{item.ManufacterName}</td>
                <td>{item.Actual}</td>
                <td>{item.Labelled}</td>
                <td>{item.Mislabelled}</td>
                <td>{item.Arsenic}</td>
                <td>{item.Cadium}</td>
                <td>{item.Lead}</td>
                <td>{item.Copper}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <Footer />
    </>
  );
}

export default TableData;
